module.exports = __webpack_public_path__ + "ebd1511aaa71477cb9b574520de685b4.png";